import { supabase } from '../../../Utilities/SupabaseClient';
import getSupplierInfoFromDB from '../../SupplierPage/Utilities/getSupplierInfoFromDB';
import getAssessmentTitle from '../../SupplierPage/Utilities/getAssessmentTitle';

// Returns an array for the bar chart. The array contains
// objects of emissions for the suppliers.
const getRecentResponses = async () => {
	try {
		const session = await supabase.auth.getSession();
		const userid = session.data.session.user.id;
		const { data, err } = await supabase
			.from('assessments_sent')
			.select('*')
			.eq('response', true)
			.eq('sending_user_id', userid)
			.order('created_at', { ascending: false })
			.limit(15);
		// Error block here in case the catch block does not
		// recognize the error. Not sure how Supabase handles the error
		// message so including this here. May not be necessary.
		if (err) throw err;
		if (data) {
			const supplierData = await Promise.all(
        data.map(async (item) => {
          try {
            const date = new Date(item['created_at']).toDateString();
            const supplierInfo = await getSupplierInfoFromDB(item['supplier_uuid']);
      
            if (!supplierInfo) {
              console.error(`Supplier info not found for UUID: ${item['supplier_uuid']}`);
              return null; // Skip this entry
            }
      
            return {
              company: supplierInfo['company_name'],
              assessment: getAssessmentTitle(item['assessment_number']),
              uuid: item['assessment_uuid'],
              date,
            };
          } catch (error) {
            console.error(`Error processing item: ${item['supplier_uuid']}`, error);
            return null;
          }
        })
      );
      
      return supplierData.filter(Boolean).slice(0, 9);
      

		
		}
	} catch (e) {
		console.log(e);
		throw e;
	}
};

export default getRecentResponses;
